import { z } from "zod";

/**
 * URL search params are parsed as JSON by the router, so "?new=1" arrives as the number 1 and
 * "?q=11427" as a number too. These helpers accept either and never throw on odd input.
 */
export const searchText = z.coerce.string().optional().catch(undefined);
export const searchFlag = searchText;
export const searchEnum = <T extends readonly [string, ...string[]]>(values: T) =>
  z.enum(values).optional().catch(undefined);
